import React from 'react'

export const LiveQuizEvents = () => {
  return (
    <></>
  )
}
